// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled, {css} from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:DropdownWrap'); // eslint-disable-line no-unused-vars
import { ThemeType } from 'trustar-2.0/types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {List} from 'immutable';
import {noop} from 'rxjs/util/noop';

// Style for Main Components (things you may export)
const StyledDropdownWrap = styled.div`
  .dropdown .dropdown-menu {
    min-width: 1rem;
    padding: 0;
    
    ${({menuBorderStyle}) => menuBorderStyle && css`
        border: ${menuBorderStyle};
    `};
    
    &.show {
      margin: 0;
    }
    > * {
      width: 100%;
      user-select: none;
    }
  }
`;

const initialValues = {
  dropdownOpen: false,
  direction: 'down',
};

// Bindings
type DropdownWrapProps = {
  theme?: ThemeType,
  dropdownOpen?: boolean,
  children?: any,
  menuItems: List<React.Element<*>> | Array<React.Element<*>>,
  direction?: string,
  openOnHover?: boolean,
  openOnClick?: boolean,
  dropdownCyId?: string,
  dropdownMenuCyId?: string,
  dropdownItemContainerBorderStyle?: string,
};

class DropdownWrap extends Component {
  props: DropdownWrapProps;
  static defaultProps = initialValues;
  state = {
    dropdownOpen: false,
    mouseInMenu: false,
  };
//  ----Template----

  render() {
    /**
     * If you have both openOnHover and openOnClick, openOnHover takes precedence
     */
    const {openOnHover, openOnClick, dropdownItemContainerBorderStyle} = this.props;

    return (
      <StyledDropdownWrap menuBorderStyle={dropdownItemContainerBorderStyle}>
        <Dropdown
          direction={this.props.direction}
          isOpen={this.state.dropdownOpen}
          toggle={openOnClick && !openOnHover ? this.toggle : noop}
          data-cy={this.props.dropdownCyId}
        >
          <DropdownToggle tag={'div'} onMouseEnter={openOnHover ? this.openDropdown : null} onMouseLeave={openOnHover ? this.closeDropdown : null}>
            {this.props.children}
          </DropdownToggle>
          <DropdownMenu data-cy={this.props.dropdownMenuCyId}>
            {this.props.menuItems.map((Item) => React.cloneElement(Item, {
              onClick: this.closeDropdown,
            }))}
          </DropdownMenu>
        </Dropdown>
      </StyledDropdownWrap>
    );
  }// ----Methods----
  openDropdown = () => {
    this.setState(prevState => ({
      dropdownOpen: true
    }));
  };
  closeDropdown = () => {
    this.setState(prevState => ({
      dropdownOpen: false
    }));
  };
  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    })
    );
  };
}

// Logic & Helper Components
const StyledMenuItem = styled.div`
    border: 0;
    padding: ${props => props.noPadding ? 'initial' : '0.5rem 2rem'};
    font-size: ${({theme}) => theme.FontSizes.P};
    cursor: pointer;
    background-color: ${({theme}) => theme.ThemeColors.SURFACE_LIGHTER.X700};
    & > a {
      color: ${({theme}) => theme.ThemeColors.TEXT.hex};
    }
`;
const DropdownWrapMenuItem = (props: Object) => {
  return (
    <StyledMenuItem noPadding={props.noPadding}>
      {props.children}
    </StyledMenuItem>
  );
};


export {DropdownWrap, DropdownWrapMenuItem};


// WEBPACK FOOTER //
// ./src/app/components/browse/components/DropdownWrap.js